import { useDragLayer } from "react-dnd";
import { forwardRef, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { cn } from "../utils";
import { TextArea } from "@radix-ui/themes";
import { useGSAP } from "@gsap/react";
import useStore from "../hooks/useStore";

export const CustomDragLayer = (props) => {
  const { itemType, isDragging, currentOffset, initialOffset } = useDragLayer(
    (monitor) => ({
      itemType: monitor.getItemType(),
      currentOffset: monitor.getSourceClientOffset(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  const promptIndicator = useStore((state) => state.promptIndicator);

  const layerStyles = {
    position: "fixed",
    pointerEvents: "none",
    zIndex: 300,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.7,
  };

  const dragProxyRef = useRef(null);
  const [initiated, setInitiated] = useState(false);

  useGSAP(() => {
    if (currentOffset && initiated) {
      gsap.to(dragProxyRef.current, {
        x: currentOffset.x + 25,
        y: currentOffset.y - 12,
        opacity: 1,
      });
      gsap.to(dragProxyRef.current, {
        width: promptIndicator.length * 10 + 20,
        height: 40,
        duration: 2,
        ease: "elastic.out(1, 0.3)",
      });
    } else if (currentOffset) {
      gsap.from(dragProxyRef.current, {
        x: initialOffset.x + 120,
        y: initialOffset.y + 100,
        opacity: 0,
      });
      setInitiated(true);
    }
  }, [currentOffset]);

  useEffect(() => {
    if (!isDragging) {
      setInitiated(false);
    }
  }, [isDragging]);

  if (!isDragging) {
    return null;
  }
  return (
    <div style={layerStyles}>
      <div
        className={cn("dragging-item", `dragging-${itemType}`)}
        ref={dragProxyRef}
      >
        <div className="content">{promptIndicator}</div>
      </div>
    </div>
  );
};
